import { AUTH_FAILED, AUTH_PASSED, VERIFYUSER } from "../types";

const initialState = {
	user: {},
	isAuth: false,
	error: false,
	message: "",
	title: "",
};

//selectors
export const getUser = (state) => state.auth.user;
export const getAuth = (state) => state.auth;

//reducers
export const authReducer = (state = initialState, action) => {
	// console.log("I am the auth reducer action ======> ", action);
	switch (action.type) {
		case "SIGNIN":
			return {
				...state,
				isAuth: true,
				error: false,
				user: action.payload,
			};
		case "SIGNUP":
			return {
				...state,
				isAuth: true,
				error: false,
				user: action.payload,
			};
		case VERIFYUSER:
			return {
				...state,
				isAuth: true,
				error: false,
				message: action.payload || action.message,
				title: action.title,
			};
		case AUTH_FAILED:
			return {
				...state,
				error: true,
				message: action.payload,
				title: action.title,
				code: action.code,
			};
		case AUTH_PASSED:
			return {
				...state,
				error: false,
				message: action.payload || action.message,
				title: action.title,
			};
		default:
			return {
				...state,
			};
	}
};
